import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { MatRadioChange } from '@angular/material/radio';
import { LocalStorageService } from 'src/app/services/local-storage.service';

@Component({
    selector: 'app-select-filter',
    templateUrl: './select-filter.component.html',
    styleUrls: ['./select-filter.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HistoryFilterComponent implements OnInit {
  constructor(private localStorageService: LocalStorageService) {}

  @Input() cachename: string;

  @Input() filterOptions: FilterOption[];
  selectedOption: FilterOption;

  @Output() filterChange: EventEmitter<number> = new EventEmitter();

  get cachekey() {
    return `history-filter-${this.cachename}`;
  }

  ngOnInit(): void {
    let cached: FilterOption = this.localStorageService.get(this.cachekey);
    if (cached && cached.id) {
      this.selectedOption = this.filterOptions.find((x) => x.id == cached.id);
    } else {
      let unfiltered = this.filterOptions.find((x) => x.isUnfilteredOption);
      this.selectedOption = unfiltered ? unfiltered : this.filterOptions[0];
    }
    this.filterChange.emit(this.selectedOption.id);
  }

  filterChanged(event: MatRadioChange) {
    this.selectedOption = this.filterOptions.find((x) => x.id === event.value);
    this.localStorageService.set(this.cachekey, this.selectedOption);
    this.filterChange.emit(event.value);
  }
}

export class FilterOption {
  text: string;
  id: number;
  isUnfilteredOption: boolean;

  public constructor(id: number, text: string, isUnfilteredOption: boolean = false) {
    this.id = id;
    this.text = text;
    this.isUnfilteredOption = isUnfilteredOption;
  }
}
